
(function () {
  'use strict';

  function showForVariant(variantId) {
    if (!variantId) return;
    document.querySelectorAll('.variant--text--show').forEach(function (group) {
      group.querySelectorAll('.model_product').forEach(function (el) {
        el.style.display = String(el.dataset.variantId) === String(variantId) ? 'flex' : 'none';
      });
    });
  }
  
  function variantFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches('input[name="id"]')) {
      showForVariant(target.value);
    }
  });

  function syncFromUrl() {
    var id = variantFromUrl();
    if (id) showForVariant(id);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromUrl);
  } else {
    syncFromUrl();
  }
  window.addEventListener('popstate', syncFromUrl);
})();
